import React, { useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Select,
  TimePicker,
  Radio,
  Row,
  Col,
} from "antd";
import dayjs from "dayjs";
import useGetApi from "../../services/useGetApi";
import usePost from "../../services/usePost";
import { useParams } from "react-router-dom";

const { TextArea } = Input;

const AddQuiz = ({ 
  addQuizBtn, setAddQuizBtn, 
  loadSections, mode, quizId, quizSectionId 
}) => {
  const [form] = Form.useForm();
  const [sectionSelect, setSectionSelect] = useState([]);
  const { id } = useParams();
  const [sectionId, setSectionId] = useState();
  const [createQuiz, setCreateQuiz] = useState({
    courseId: id,
    sectionId: sectionId,
    title: "",
    duration: "",
    totalMarks: "",
    passMarks: "",
    numberOfRetakes: "",
    dripContentRule: "",
    instructions: "",
  });

  const [sectionsIsLoading, sectionsError, sections, getSections] = useGetApi(
    `course/details/${id}`,
    [],
    true
  );

  const [editIsLoading, editquizError, editQuiz, getQuiz] = useGetApi(
    ``,
    [],
    true
  );

  const [isPostLoading, postError, postData] = usePost();

  useEffect(() => {
    getSections(`course/details/${id}`);
  }, [id]);

  useEffect(() => {
    if (mode === "edit") {
      getQuiz(`sections/course/${id}/section/${quizSectionId}/quiz/${quizId}`);
    }
  }, [mode]);

  const transformDuration = (isoDuration) => {
    // Extract hours, minutes, and seconds using regex
    const hoursMatch = isoDuration.match(/(\d+)H/);
    const minutesMatch = isoDuration.match(/(\d+)M/);
    const secondsMatch = isoDuration.match(/(\d+)S/);
  
    // Extract values or default to 0
    const hours = hoursMatch ? hoursMatch[1] : '00';
    const minutes = minutesMatch ? minutesMatch[1] : '00';
    const seconds = secondsMatch ? secondsMatch[1] : '00';
  
    // Format as HH:mm:ss
    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
  };

  useEffect(() => {
    if (editQuiz && editQuiz.duration) {
      setCreateQuiz(editQuiz)
    
      const formattedDuration = transformDuration(editQuiz.duration);

      const initialValues = {
        title: editQuiz.title,
        section: editQuiz.sectionId,
        duration: dayjs(formattedDuration, "HH:mm:ss"),
        totalMarks: editQuiz.totalMarks,
        passMark: editQuiz.passMarks,
        dripContentRule: editQuiz?.dripContentRule?.trim(),
        numberOfRetakes: editQuiz.numberOfRetakes,
        instruction: editQuiz.instructions,
      };

      form.setFieldsValue(initialValues);
    }
  }, [editQuiz, form]);

  useEffect(() => {
    if (sections) {
      const formattedOptions = sections?.sections?.map((section) => ({
        value: section.id,
        label: section.title,
      }));
      setSectionSelect(formattedOptions);
    }
  }, [sections]);

  const handleChange = (value, field) => {
    setCreateQuiz((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const convertToPTFormat = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const ptFormat = `PT${hours}H${minutes}M${seconds}S`;
    return ptFormat;
  };

  const handleTimeChange = (time, timeString) => {
    const ptFormattedTime = convertToPTFormat(timeString);
    handleChange(ptFormattedTime, "duration");
  };

  const handleSubmit = async () => {
    const quizData = { ...createQuiz };

      const response = await postData(
        `sections/course/${id}/section/${quizSectionId}/quiz`,
        quizData,
        true
      );
      if (response) {
        loadSections(`course/details/${id}`);
        setAddQuizBtn(false);
      }
 
  };


  // useEffect(() => {
  //   console.log(createQuiz)
  // },[createQuiz])

  return (
    <div>
      {addQuizBtn && (
        <div className="popup-overlay"  style={{marginTop:'20px'}}>
          <div className="popup-container p-20">
            <Row gutter={16}>
              <Col span={12}>
                <h5>{mode === "edit" ? "Edit Quiz" : "Add New Quiz"}</h5>
              </Col>
              <Col span={12}>
                <button
                  className="close-btn"
                  onClick={() => setAddQuizBtn(false)}
                >
                  <CloseOutlined />
                </button>
              </Col>
            </Row>

            <Row className="popup_horizontal_line"></Row>

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                label="Quiz Title"
                name="title"
                rules={[{ required: true, message: "Please input the quiz title!" }]}
              >
                <Input
                  value={createQuiz.title}
                  onChange={(e) => handleChange(e.target.value, "title")}
                />
              </Form.Item>

              <Form.Item
                label="Section"
                name="section"
                rules={[{ required: true, message: "Please select a section!" }]}
              >
                <Select
                  options={sectionSelect}
                  placeholder="Add section"
                  value={createQuiz.sectionId}
                  onChange={(value) => {
                    setSectionId(value);
                    handleChange(value, "sectionId");
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Quiz Duration"
                name="duration"
                rules={[{ required: true, message: "Please select quiz duration!" }]}
              >
                <TimePicker
                  defaultValue={dayjs("00:00:00", "HH:mm:ss")}
                  onChange={handleTimeChange}
                  size="large"
                  className="w-100"
                />
              </Form.Item>
              {/* <p className="light_grey">
                If you want to disable the timer, set the duration to 00:00:00.
              </p> */}

              <Form.Item
                label="Total Marks"
                name="totalMarks"
                rules={[{ required: true, message: "Please input the total marks!" }]}
              >
                <InputNumber
                  className="w-100"
                  value={createQuiz.totalMarks}
                  onChange={(value) => handleChange(value, "totalMarks")}
                />
              </Form.Item>

              <Form.Item
                label="Pass Mark"
                name="passMark"
                rules={[{ required: true, message: "Please input the pass mark!" }]}
              >
                <InputNumber
                  className="w-100"
                  value={createQuiz.passMarks}
                  onChange={(value) => handleChange(value, "passMarks")}
                />
              </Form.Item>

              <Form.Item
                label="Drip Content Rule for Quiz"
                name="dripContentRule"
                rules={[{ required: true, message: "Please select a drip content rule!" }]}
              >
                <Radio.Group
                  options={[
                    {
                      value: "Students can start the next lesson by submitting the quiz",
                      label: "Students can start the next lesson by submitting the quiz",
                    },
                    {
                      value: "Students must achieve pass mark to start the next lesson",
                      label: "Students must achieve pass mark to start the next lesson",
                    },
                  ]}
                  value={createQuiz.dripContentRule}
                  onChange={(e) => handleChange(e.target.value, "dripContentRule")}
                />
              </Form.Item>

              <Form.Item
                label="Number of Quiz Retakes"
                name="numberOfRetakes"
                rules={[{ required: true, message: "Please input the number of quiz retakes!" }]}
              >
                <InputNumber
                  className="w-100"
                  value={createQuiz.numberOfRetakes}
                  onChange={(value) => handleChange(value, "numberOfRetakes")}
                />
                {/* <p className="light_grey">
                  Enter 0 if you want to disable multiple attempts
                </p> */}
              </Form.Item>

              <Form.Item
                label="Instruction"
                name="instruction"
                rules={[{ required: true, message: "Please input the instructions!" }]}
              >
                <TextArea
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  value={createQuiz.instructions}
                  onChange={(e) => handleChange(e.target.value, "instructions")}
                />
              </Form.Item>

              <Row className="submit_btn_div" justify="center">
                <button  className="popup_submit_btn" 
                  htmlType="submit"
                >
                  Submit
                </button>
              </Row>
            </Form>

            <Row className="popup_horizontal_line"></Row>
            <Row className="back_btn_div mt-10">
              <button
                className="popup_back_btn"
                onClick={() => setAddQuizBtn(false)}
              >
                Back
              </button>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddQuiz;
